/** * @author Akhila Sattarapu * @email 83606@global.ul.com * @create date 2019-12-26 15:17:50 *
@modify date 2019-12-26 15:17:50 * @desc Confirmation modal */
<template>
  <div>
    <div id="modal_confirm" class="modal custom" role="dialog">
      <div class="modal-dialog request-modal" :class="{ 'wd-50': body_text === 'default' }">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" @click="reset()">&times;</button>
            <template v-if="body_text === 'default'">
              <div>
                <h3 class="confirm_title">Quote Request</h3>
              </div>
              <div>
                <form class="request-form">
                  <div class="form-group">
                    <div class="pb-8">
                      Where are you located?
                      <span class="required">*</span>
                    </div>
                    <div class="row">
                      <div class="col-md-8">
                        <multiselect
                          v-model="selectedCountry"
                          placeholder="Select Country"
                          label="country_name"
                          :searchable="true"
                          :allow-empty="false"
                          :showLabels="false"
                          editable="false"
                          :options="countryList"
                          class="multiselect-single-dropdown"
                          :class="!selectedCountry ? 'un-selected' : ''"
                          @select="onChangeCountry"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row pb-10"
                    v-for="(template, index) in smart_builder_templates"
                    :key="index"
                  >
                    <div class="col-md-12 col-lg-12 pb-10">
                      {{ template.question }}
                      <span class="required">*</span>
                    </div>
                    <div class="col-md-12 col-lg-12 smartbuilder_tabs">
                      <template v-if="activeTab">
                        <div class="tabs-left">
                          <ul class="nav nav-tabs" role="tablist">
                            <li
                              role="presentation"
                              class="nav-item"
                              :class="{ active: activeTab == 'european_union' }"
                            >
                              <span
                                class="nav-link"
                                role="tab"
                                @click="activeTab = 'european_union'"
                                data-toggle="tab"
                                >European Union</span
                              >
                            </li>
                            <li
                              role="presentation"
                              class="nav-item"
                              :class="{ active: activeTab == 'usa_fda' }"
                            >
                              <span
                                class="nav-link"
                                role="tab"
                                @click="activeTab = 'usa_fda'"
                                data-toggle="tab"
                                >USA FDA</span
                              >
                            </li>
                            <li
                              role="presentation"
                              class="nav-item"
                              :class="{ active: activeTab == 'latin_america' }"
                            >
                              <span
                                class="nav-link"
                                role="tab"
                                @click="activeTab = 'latin_america'"
                                data-toggle="tab"
                                >Latin America</span
                              >
                            </li>
                          </ul>
                        </div>
                      </template>
                      <div v-show="activeTab === 'european_union'">
                        <div class="select_all">
                        <span class="checkbox inline-checkbox">
                          <label>
                            <input
                              type="checkbox"
                              v-model="selectAllEurope"
                              @change="templateIndex = index"
                            />
                            <span class="cr"></span>
                          </label>
                        </span>
                        <span class="text-emergo-dark-blue ft-14 fw-500">Select all</span>
                      </div>
                        <div class="col-md-12">
                          <div
                            class="form-check"
                            v-for="(service, index_service) in template.services.european_union"
                            :key="index_service"
                          >
                            <div class="mb-5">
                              <span class="checkbox inline-checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    :value="service.id"
                                    v-model="submitData.template_id_list"
                                    @change="resetValues(index, index_service, 'european_union')"
                                  />
                                  <span class="cr"></span>
                                </label>
                              </span>
                              <span>{{ service.name }}</span>
                            </div>
                            <template v-if="submitData.template_id_list.indexOf(service.id) > -1">
                              <div
                                class="row ml-20 questions-row"
                                v-for="(question, question_index) in service.questions"
                                :key="question_index"
                              >
                                <template
                                  v-if="
                                    question.type === 'checkbox' &&
                                    (!selectedCountry ||
                                      !question.not_for_countries.includes(
                                        selectedCountry.country_name
                                      ))
                                  "
                                >
                                  <div class="col-xs-12 pb-10">
                                    <span class="checkbox inline-checkbox">
                                      <label>
                                        <input
                                          type="checkbox"
                                          v-model="question.answer"
                                          true-value="Yes"
                                          false-value="-"
                                        />
                                        <span class="cr"></span>
                                      </label>
                                    </span>
                                    <span>
                                      {{ question.question }}
                                      <span class="required" v-if="question.required">*</span>
                                    </span>
                                  </div>
                                </template>
                                <template
                                  v-if="
                                    question.type !== 'checkbox' &&
                                    (!selectedCountry ||
                                      !question.not_for_countries.includes(
                                        selectedCountry.country_name
                                      ))
                                  "
                                >
                                  <div class="col-xs-12 pb-5 pr-0">
                                    {{ question.question }}
                                    <span class="required" v-if="question.required">*</span>
                                  </div>
                                  <div
                                    class="col-xs-12 col-sm-8 pr-0"
                                    v-if="question.type === 'dropdown'"
                                  >
                                    <multiselect
                                      v-model="question.answer"
                                      placeholder="Select Answer"
                                      :options="question.values"
                                      :searchable="false"
                                      :allow-empty="false"
                                      :showLabels="false"
                                      editable="false"
                                      class="multiselect-single-dropdown"
                                      :class="!question.answer ? 'un-selected' : ''"
                                    ></multiselect>
                                  </div>
                                </template>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div v-show="activeTab === 'usa_fda'">
                        <div class="select_all">
                          <span class="checkbox inline-checkbox">
                            <label>
                              <input
                                type="checkbox"
                                :value="index"
                                v-model="selectAllNorthAmerica"
                                @change="templateIndex = index"
                              />
                              <span class="cr">
                              </span>
                            </label>
                          </span>
                          <span class="text-emergo-dark-blue ft-14 fw-500">Select all</span>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="form-check"
                            v-for="(service, index_service) in template.services.usa_fda"
                            :key="index_service"
                          >
                            <div class="mb-5">
                              <span class="checkbox inline-checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    :value="service.id"
                                    v-model="submitData.template_id_list"
                                    @change="resetValues(index, index_service, 'usa_fda')"
                                  />
                                  <span class="cr"></span>
                                </label>
                              </span>
                              <span>{{ service.name }}</span>
                            </div>
                            <template v-if="submitData.template_id_list.indexOf(service.id) > -1">
                              <div
                                class="row ml-20 questions-row"
                                v-for="(question, question_index) in service.questions"
                                :key="question_index"
                              >
                                <template
                                  v-if="
                                    question.type === 'checkbox' &&
                                    (!selectedCountry ||
                                      !question.not_for_countries.includes(
                                        selectedCountry.country_name
                                      ))
                                  "
                                >
                                  <div class="col-xs-12 pb-10">
                                    <span class="checkbox inline-checkbox">
                                      <label>
                                        <input
                                          type="checkbox"
                                          v-model="question.answer"
                                          true-value="Yes"
                                          false-value="-"
                                        />
                                        <span class="cr"></span>
                                      </label>
                                    </span>
                                    <span>
                                      {{ question.question }}
                                      <span class="required" v-if="question.required">*</span>
                                    </span>
                                  </div>
                                </template>
                                <template
                                  v-if="
                                    question.type !== 'checkbox' &&
                                    (!selectedCountry ||
                                      !question.not_for_countries.includes(
                                        selectedCountry.country_name
                                      ))
                                  "
                                >
                                  <div class="col-xs-12 pb-5 pr-0">
                                    {{ question.question }}
                                    <span class="required" v-if="question.required">*</span>
                                  </div>
                                  <div
                                    class="col-xs-12 col-sm-8 pr-0"
                                    v-if="question.type === 'dropdown'"
                                  >
                                    <multiselect
                                      v-model="question.answer"
                                      placeholder="Select Answer"
                                      :options="question.values"
                                      :searchable="false"
                                      :allow-empty="false"
                                      :showLabels="false"
                                      editable="false"
                                      class="multiselect-single-dropdown"
                                      :class="!question.answer ? 'un-selected' : ''"
                                    ></multiselect>
                                  </div>
                                </template>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div v-show="activeTab === 'latin_america'">
                        <div class="select_all">
                          <span class="checkbox inline-checkbox">
                            <label>
                              <input
                                type="checkbox"
                                v-model="selectAllSouthAmerica"
                                @change="templateIndex = index"
                              />
                              <span class="cr">
                              </span>
                            </label>
                          </span>
                          <span class="text-emergo-dark-blue ft-14 fw-500">Select all</span>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="form-check"
                            v-for="(service, index_service) in template.services.latin_america"
                            :key="index_service"
                          >
                            <div class="mb-5">
                              <span class="checkbox inline-checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    :value="service.id"
                                    v-model="submitData.template_id_list"
                                    @change="resetValues(index, index_service, 'latin_america')"
                                  />
                                  <span class="cr"></span>
                                </label>
                              </span>
                              <span>{{ service.name }}</span>
                            </div>
                            <template v-if="submitData.template_id_list.indexOf(service.id) > -1">
                              <div
                                class="row ml-20 questions-row"
                                v-for="(question, question_index) in service.questions"
                                :key="question_index"
                              >
                                <template
                                  v-if="
                                    question.type === 'checkbox' &&
                                    (!selectedCountry ||
                                      !question.not_for_countries.includes(
                                        selectedCountry.country_name
                                      ))
                                  "
                                >
                                  <div class="col-xs-12 pb-10">
                                    <span class="checkbox">
                                      <label>
                                        <input
                                          type="checkbox"
                                          v-model="question.answer"
                                          true-value="Yes"
                                          false-value="-"
                                        />
                                        <span class="cr"></span>
                                      </label>
                                    </span>
                                    <span>
                                      {{ question.question }}
                                      <span class="required" v-if="question.required">*</span>
                                    </span>
                                  </div>
                                </template>
                                <template
                                  v-if="
                                    question.type !== 'checkbox' &&
                                    (!selectedCountry ||
                                      !question.not_for_countries.includes(
                                        selectedCountry.country_name
                                      ))
                                  "
                                >
                                  <div class="col-xs-12 pb-5 pr-0">
                                    {{ question.question }}
                                    <span class="required" v-if="question.required">*</span>
                                  </div>
                                  <div
                                    class="col-xs-12 col-sm-8 pr-0"
                                    v-if="question.type === 'dropdown'"
                                  >
                                    <multiselect
                                      v-model="question.answer"
                                      placeholder="Select Answer"
                                      :options="question.values"
                                      :searchable="false"
                                      :allow-empty="false"
                                      :showLabels="false"
                                      editable="false"
                                      class="multiselect-single-dropdown"
                                      :class="!question.answer ? 'un-selected' : ''"
                                    ></multiselect>
                                  </div>
                                </template>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-xs-12"
                      v-if="
                        showDefaultQuestions(template.services) && template.common_questions.length
                      "
                    >
                      <div
                        class="row questions-row m-0"
                        v-for="(question, index_common) in template.common_questions"
                        :key="index_common"
                      >
                        <template
                          v-if="
                            question.type === 'checkbox' &&
                            (!selectedCountry ||
                              !question.not_for_countries.includes(selectedCountry.country_name))
                          "
                        >
                          <div class="col-xs-12 checkbox-block pb-10">
                            <input
                              type="checkbox"
                              v-model="question.answer"
                              true-value="Yes"
                              false-value="-"
                            />
                            <span>
                              {{ question.question }}
                              <span class="required" v-if="question.required">*</span>
                            </span>
                          </div>
                        </template>
                        <template
                          v-if="
                            question.type !== 'checkbox' &&
                            (!selectedCountry ||
                              !question.not_for_countries.includes(selectedCountry.country_name))
                          "
                        >
                          <div class="col-xs-12 pb-5">
                            {{ question.question }}
                            <span class="required" v-if="question.required">*</span>
                          </div>
                          <div class="col-xs-12 col-sm-8" v-if="question.type === 'dropdown'">
                            <multiselect
                              v-model="question.answer"
                              placeholder="Select Answer"
                              :options="question.values"
                              :searchable="false"
                              :allow-empty="false"
                              :showLabels="false"
                              editable="false"
                              class="multiselect-single-dropdown"
                              :class="!question.answer ? 'un-selected' : ''"
                            ></multiselect>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="country-header">
                      Comments <span style="color: rgb(0, 0, 0, 0.5)">(optional)</span>
                    </div>
                    <textarea class="form-control" rows="4" v-model="comment"></textarea>
                  </div>
                </form>
              </div>
            </template>
            <template v-else>
              <div class="p-confirm">
                <div>
                  <img
                    src="/static/images/icons/check_icon.svg"
                    class="check_img"
                    alt="check-icon"
                  />
                  <h3 class="confirm_title">Thanks for your request!</h3>
                </div>
                <div>Our Sales Team will contact you soon.</div>
              </div>
            </template>
          </div>
          <div class="modal-footer" v-if="body_text === 'default'">
            <button
              type="button"
              class="btn emergo-green-button"
              :disabled="disableSubmit"
              @click="requestService()"
            >
              Submit
            </button>
          </div>
          <div class="modal-footer" v-else>
            <button type="button" class="btn emergo-blue-button" @click="reset()">OK</button>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import getJSONresponse from '../../apis/responseJSON';
import { postPlan } from '../../apis/psm';
import { getSasToken } from '../../apis/regsAndGuidance';
import Loader from '../UIComponents/Loader.vue';

export default {
  props: ['planDetails'],
  components: {
    Loader
  },
  data() {
    return {
      activeTab: '',
      body_text: 'default',
      submitData: {
        country: '',
        template_id_list: [],
        answers: []
      },
      comment: '',
      smart_builder_templates: [],
      countryList: [],
      loaderStatus: false,
      usFDAIds: [],
      latinAmericaIds: [],
      europeanUnionIds: [],
      templateIndex: null,
      selectedCountry: null
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    onChangeCountry(selectedOption) {
      // reset the values if the selected country is in the list of not to show
      this.smart_builder_templates.forEach((template, i) => {
        template.common_questions.forEach((question, j) => {
          if (question.not_for_countries.includes(selectedOption.country_name)) {
            this.smart_builder_templates[i].common_questions[j].answer = '';
          }
        });
        template.services.european_union.forEach((service, k) => {
          service.questions.forEach((question, l) => {
            if (question.not_for_countries.includes(selectedOption.country_name)) {
              this.smart_builder_templates[i].services.european_union[k].questions[l].answer = '';
            }
          });
        });
        template.services.usa_fda.forEach((service, k) => {
          service.questions.forEach((question, l) => {
            if (question.not_for_countries.includes(selectedOption.country_name)) {
              this.smart_builder_templates[i].services.usa_fda[k].questions[l].answer = '';
            }
          });
        });
        template.services.latin_america.forEach((service, k) => {
          service.questions.forEach((question, l) => {
            if (question.not_for_countries.includes(selectedOption.country_name)) {
              this.smart_builder_templates[i].services.latin_america[k].questions[l].answer = '';
            }
          });
        });
      });
    },
    resetValues(template, serviceIndex, country) {
      if (
        this.submitData.template_id_list.indexOf(
          this.smart_builder_templates[template].services[country][serviceIndex].id
        ) === -1
      ) {
        this.resetServiceAnswers(template, serviceIndex, country);
      }
      const ids = this.smart_builder_templates[template].services[country].map(
        (service) => service.id
      );
      if (!ids.every((id) => this.submitData.template_id_list.includes(id))) {
        this.resetCommonAnswers(template);
      }
    },
    resetServiceAnswers(template, service, country) {
      for (
        let i = 0;
        i < this.smart_builder_templates[template].services[country][service].questions.length;
        i += 1
      ) {
        this.smart_builder_templates[template].services[country][service].questions[i].answer = '';
      }
    },
    resetCommonAnswers(template) {
      for (let i = 0; i < this.smart_builder_templates[template].common_questions.length; i += 1) {
        this.smart_builder_templates[template].common_questions[i].answer = '';
      }
    },
    validateCheckedService() {
      let invalid = true;
      let validAns = false;
      let validCommon = false;
      this.smart_builder_templates.forEach((template) => {
        const europeanUnionIds = template.services.european_union.map((service) => service.id);
        const usFDAIds = template.services.usa_fda.map((service) => service.id);
        const latinAmericaIds = template.services.latin_america.map((service) => service.id);
        const ids = [...europeanUnionIds, ...usFDAIds, ...latinAmericaIds];

        Object.keys(template.services).forEach((region) => {
          template.services[region].forEach((service) => {
            if (this.submitData.template_id_list.includes(service.id)) {
              validAns = service.questions.some(
                (question) =>
                  !question.not_for_countries.includes(this.selectedCountry.country_name) &&
                  question.required &&
                  question.answer === ''
              );
              if (ids.every((id) => this.submitData.template_id_list.includes(id))) {
                validCommon = template.common_questions.some(
                  (question) =>
                    !question.not_for_countries.includes(this.selectedCountry.country_name) &&
                    question.required &&
                    question.answer === ''
                );
                if (validAns || validCommon) {
                  invalid = false;
                }
              } else if (validAns) {
                invalid = false;
              }
            }
          });
        });
      });
      return invalid;
    },
    createdServiceAnswerObj(services, headerId) {
      const obj = [];
      services.questions.forEach((question) => {
        if (!question.not_for_countries.includes(this.selectedCountry.country_name)) {
          const quest = {
            header_id: headerId,
            template_name: services.name,
            question_id: question.id,
            question: question.question
          };
          if (question.type === 'checkbox') {
            quest.answer = question.answer && question.answer === 'Yes' ? 'Yes' : '-';
          } else {
            quest.answer = question.answer ? question.answer : '-';
          }
          obj.push(quest);
        }
      });
      return obj;
    },
    createdCommonAnswerObj(template) {
      const obj = [];
      const europeanUnionIds = template.services.european_union.map((service) => service.id);
      const usFDAIds = template.services.usa_fda.map((service) => service.id);
      const latinAmericaIds = template.services.latin_america.map((service) => service.id);
      const ids = [...europeanUnionIds, ...usFDAIds, ...latinAmericaIds];

      if (ids.every((id) => this.submitData.template_id_list.includes(id))) {
        template.common_questions.forEach((question) => {
          if (!question.not_for_countries.includes(this.selectedCountry.country_name)) {
            const quest = {
              header_id: template.id,
              template_name: 'Common Question',
              question_id: question.id,
              question: question.question,
              answer: question.answer ? question.answer : '-'
            };
            obj.push(quest);
          }
        });
      }
      return obj;
    },
    createdFormData() {
      let answers = [];
      let answer = [];
      let commonAnswobj = [];
      let commonAnswer = [];
      this.smart_builder_templates.forEach((template) => {
        commonAnswer = this.createdCommonAnswerObj(template);
        commonAnswobj = [...commonAnswobj, ...commonAnswer];
        Object.keys(template.services).forEach((region) => {
          template.services[region].forEach((service) => {
            if (this.submitData.template_id_list.indexOf(service.id) !== -1) {
              answer = this.createdServiceAnswerObj(service, template.id);
              answers = [...answers, ...answer];
            }
          });
        });
      });
      this.submitData.answers = [...answers, ...commonAnswobj];
      this.submitData.country = this.selectedCountry.country_code;
      if (this.comment) this.submitData.comment = this.comment;
    },
    /* requestService()
     * to request the service for the accountId
     */
    async requestService() {
      this.createdFormData();
      this.loaderStatus = true;
      const formData = {
        account_id: JSON.parse(localStorage.getItem('userData')).account_id,
        active: true,
        operation: 5,
        payment_mode: 5,
        plan_id: this.planDetails.id,
        plan_price: this.planDetails.price,
        service_type: 'trial',
        total_amount: 0,
        valid_from: moment.utc(),
        valid_until: moment.utc().add(1, 'years').subtract(1, 'days'),
        smart_builder: this.submitData
      };
      const response = await postPlan(formData);
      this.loaderStatus = false;
      if (response.message === 'success' && response.status_code === 200) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Request Quote - Success'
        });
        this.body_text = 'submited';
        this.activeTab = '';
        this.submitData = {
          country: '',
          template_id_list: [],
          answers: []
        };
        this.selectedCountry = null;
        this.comment = '';
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: response.data,
          group: 'custom-notification'
        });
      }
    },
    /**
     * reset()
     * Hides the modal popup and resets the confirmation popup
     */
    reset() {
      this.body_text = 'default';
      this.submitData = {
        country: '',
        template_id_list: [],
        answers: []
      };
      this.selectedCountry = null;
      this.comment = '';
      this.activeTab = '';
      this.smart_builder_templates.forEach((template, i) => {
        this.resetCommonAnswers(i);
        Object.keys(template.services).forEach((region) => {
          template.services[region].forEach((service, index) => {
            this.resetServiceAnswers(i, index, region);
          });
        });
      });
      $('#modal_confirm').modal('hide');
    },
    async getCountriesList() {
      const url = `${process.env.VUE_APP_AZURE_BLOB_URL}/market-place/quote_request/qrc.json`;
      const formData = this.$parent.getFormData(url);
      const token = await getSasToken(formData);
      if (token.message === 'success') {
        this.countryList = await getJSONresponse(`${url}?${token.data}`);
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Something went wrong please try after some time.',
          group: 'custom-notification'
        });
      }
    },
    async getTemplates() {
      const url = `${process.env.VUE_APP_AZURE_BLOB_URL}/market-place/quote_request/request-a-quote-sb.json`;
      const formData = this.$parent.getFormData(url);
      const token = await getSasToken(formData);
      this.smart_builder_templates = await getJSONresponse(`${url}?${token.data}`);
      this.smart_builder_templates.forEach((template) => {
        this.europeanUnionIds = template.services.european_union.map((service) => service.id);
        this.usFDAIds = template.services.usa_fda.map((service) => service.id);
        this.latinAmericaIds = template.services.latin_america.map((service) => service.id);
      });
    },
    showDefaultQuestions(services) {
      const europeanUnionIds = services.european_union.map((service) => service.id);
      const usFDAIds = services.usa_fda.map((service) => service.id);
      const latinAmericaIds = services.latin_america.map((service) => service.id);
      const ids = [...europeanUnionIds, ...usFDAIds, ...latinAmericaIds];

      return ids.every((id) => this.submitData.template_id_list.includes(id));
    }
  },
  computed: {
    /**
     * disableSubmit() to disable/enable the button based on required fields and also on input change
     */
    disableSubmit() {
      if (
        this.selectedCountry &&
        this.submitData.template_id_list &&
        this.submitData.template_id_list.length &&
        this.validateCheckedService()
      ) {
        return false;
      }
      return true;
    },
    selectAllEurope: {
      get() {
        let europeanUnionSelectall = true;
        this.europeanUnionIds.forEach((id) => {
          if (!this.submitData.template_id_list.includes(id)) europeanUnionSelectall = false;
        });
        return europeanUnionSelectall;
      },
      set(value) {
        if (value) {
          this.europeanUnionIds.forEach((id) => {
            if (!this.submitData.template_id_list.includes(id))
              this.submitData.template_id_list.push(id);
          });
        } else {
          this.europeanUnionIds.forEach((id, index) => {
            const indexEuropeId = this.submitData.template_id_list.findIndex(
              (europeId) => europeId === id
            );
            if (indexEuropeId !== -1) {
              this.submitData.template_id_list.splice(indexEuropeId, 1);
              this.resetValues(this.templateIndex, index, 'european_union');
            }
          });
        }
      }
    },
    selectAllNorthAmerica: {
      get() {
        let northAmericaIdSelectall = true;
        this.usFDAIds.forEach((id) => {
          if (!this.submitData.template_id_list.includes(id)) northAmericaIdSelectall = false;
        });
        return northAmericaIdSelectall;
      },
      set(value) {
        if (value) {
          this.usFDAIds.forEach((id) => {
            if (!this.submitData.template_id_list.includes(id))
              this.submitData.template_id_list.push(id);
          });
        } else {
          this.usFDAIds.forEach((id, index) => {
            const indexNorthId = this.submitData.template_id_list.findIndex(
              (europeId) => europeId === id
            );
            if (indexNorthId !== -1) {
              this.submitData.template_id_list.splice(indexNorthId, 1);
              this.resetValues(this.templateIndex, index, 'usa_fda');
            }
          });
        }
      }
    },
    selectAllSouthAmerica: {
      get() {
        let southAmericaIdSelectall = true;
        this.latinAmericaIds.forEach((id) => {
          if (!this.submitData.template_id_list.includes(id)) southAmericaIdSelectall = false;
        });
        return southAmericaIdSelectall;
      },
      set(value) {
        if (value) {
          this.latinAmericaIds.forEach((id) => {
            if (!this.submitData.template_id_list.includes(id))
              this.submitData.template_id_list.push(id);
          });
        } else {
          this.latinAmericaIds.forEach((id, index) => {
            const indexSouthId = this.submitData.template_id_list.findIndex(
              (europeId) => europeId === id
            );
            if (indexSouthId !== -1) {
              this.submitData.template_id_list.splice(indexSouthId, 1);
              this.resetValues(this.templateIndex, index, 'latin_america');
            }
          });
        }
      }
    }
  },
  async mounted() {
    this.getCountriesList();
    this.getTemplates();
    this.body_text = 'default';
    $('#modal_confirm').on('shown.bs.modal', () => {
      this.activeTab = 'european_union';
    });
  }
};
</script>

<style scoped>

.pr-0 {
  padding-right: 0;
}
.pb-5 {
  padding-bottom: 5px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pl-17 {
  padding-left: 17px;
}
.ml-20 {
  margin-left: 20px;
}
.p-confirm {
  padding: 30px 50px 20px 50px;
}
.request-modal {
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.request-modal.wd-50 {
  width: 50%;
}
.request-form {
  border-top: 0.5px solid #808080 !important;
  text-align: left !important;
  padding: 15px 30px 0px 30px;
  max-height: 500px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.request-form .form-check {
  margin-bottom: 10px;
}
.request-form .form-check span {
  padding-top: 1px;
  display: inline;
  font-size: 14px;
}
.country-header {
  padding-top: 12px;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: normal;
  line-height: 19px;
}
.country-header textarea {
  box-shadow: none;
}
.country-select {
  border: 1px solid #808080;
  box-sizing: border-box;
  border-radius: 20px;
}
.check_img {
  width: 50px;
  background: #4c9e45;
  padding: 6px;
  border-radius: 50px;
  height: 50px;
}
.confirm_title {
  color: #0c3859;
  margin: 15px 0px 15px 0px;
}
.custom .close {
  font-size: 25px !important;
  color: #808080d9 !important;
  background-color: #fff !important;
  top: 0 !important;
  right: 0 !important;
}
.custom .modal-footer {
  border: none !important;
  background-color: #fff !important;
}
.modal-body {
  padding-bottom: 0px;
}
.questions-row {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  padding-top: 5px;
}
.required {
  color: red;
}
.checkbox-block {
  display: inline-flex;
}

@media only screen and (max-width: 767px) {
  .request-modal.wd-50 {
    width: 95%;
  }
  .questions-row div {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  .request-modal {
    width: 60%;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .request-modal {
    height: 550px;
  }
}

/* Tabs */
::v-deep .smartbuilder_tabs .el-tabs__item {
  font-size: 16px;
}
.select_all {
  margin: 8px 2px;
  border-bottom: 0.5px dashed #bdbdbd;
  padding: 5px 0px 10px;
}
</style>
